export default __webpack_public_path__ + "static/media/LENS_CULINARIS_OGRE_fragment_3.53647c3e.jpg";